import styled from 'styled-components';
import { formatUsdCents } from '../../lib/pricing/formatMoney';
import type { PriceBookSku } from '../../lib/pricebook/pricebook';

const Wrap = styled.section`
  display: grid;
  gap: 0.65rem;
`;

const Item = styled.div<{ $included?: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 12px;
  padding: 0.85rem 1rem;
  background: ${({ theme, $included }) =>
    $included ? `${theme.colors.primary}10` : theme.colors.gray050};
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
`;

const Name = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.gray900};
  font-weight: 600;
`;

const Description = styled.p`
  margin: 0.25rem 0 0;
  color: ${({ theme }) => theme.colors.gray700};
  font-size: 0.9rem;
`;

const Amount = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
`;

type AddOnSelectorProps = {
  readonly addOns: readonly PriceBookSku[];
  readonly includedSkuIds?: readonly string[];
};

export default function AddOnSelector({
  addOns,
  includedSkuIds = [],
}: AddOnSelectorProps) {
  if (!addOns.length) return null;
  const included = new Set(includedSkuIds);

  return (
    <Wrap aria-label="Add-ons">
      {addOns.map((addOn) => {
        const isIncluded = included.has(addOn.skuId);
        return (
          <Item key={addOn.skuId} $included={isIncluded}>
            <div>
              <Name>
                {addOn.name}
                {isIncluded ? ' (included)' : ''}
              </Name>
              <Description>{addOn.description}</Description>
            </div>
            <Amount>{formatUsdCents(addOn.amountCents)}</Amount>
          </Item>
        );
      })}
    </Wrap>
  );
}

